const FADE = 260; // ms — must match CSS transition duration
const STAGGER = 35; // ms delay between each card fading in

export function initActorsFilter() {
   const page = document.querySelector('.actors-page');
   if (!page) return;

   const tabs = page.querySelectorAll('.actors-tabs__item');
   const cards = [...page.querySelectorAll('.actor-card')];
   const grid = page.querySelector('.actors-grid');
   const viewBtns = page.querySelectorAll('.actors-view-toggle__item');
   let pending = null;

   // ── View toggle ────────────────────────────────────────────────────────────

   viewBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
         e.preventDefault();
         if (btn.classList.contains('is-active')) return;
         viewBtns.forEach((b) => b.classList.remove('is-active'));
         btn.classList.add('is-active');

         grid.classList.add('is-fading');
         setTimeout(() => {
            grid.classList.toggle('actors-grid--list', btn.dataset.view === 'list');
            grid.classList.remove('is-fading');
         }, 220);
      });
   });

   function applyFilter(gender) {
      clearTimeout(pending);

      const toShow = cards.filter((c) => gender === 'all' || c.dataset.gender.split(' ').includes(gender));
      const toHide = cards.filter((c) => gender !== 'all' && !c.dataset.gender.split(' ').includes(gender));

      // Phase 1 — fade out ALL visible cards (including ones that will come back)
      cards.forEach((card) => {
         if (card.style.display !== 'none') card.classList.add('is-out');
      });

      // Phase 2 — after fade-out: hide outgoing, stagger-fade-in incoming
      pending = setTimeout(() => {
         toHide.forEach((card) => {
            card.style.display = 'none';
            card.classList.remove('is-out');
         });

         toShow.forEach((card, i) => {
            card.style.display = '';
            card.classList.add('is-out'); // ensure faded before animating in
            setTimeout(() => card.classList.remove('is-out'), i * STAGGER);
         });
      }, FADE);
   }

   const labelToSlug = (label) => label.trim().toLowerCase().replace(/\s+/g, '-');
   const findTabBySlug = (slug) => [...tabs].find((t) => labelToSlug(t.textContent) === slug);

   function activateTab(slug) {
      const match = slug ? findTabBySlug(slug) : tabs[0];
      if (!match) return;
      tabs.forEach((t) => t.classList.remove('is-active'));
      match.classList.add('is-active');
      applyFilter(match.dataset.filter);
   }

   tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
         e.preventDefault();
         const slug = labelToSlug(tab.textContent);
         const isAll = tab.dataset.filter === 'all';
         history.pushState({ slug }, '', isAll ? location.pathname : `#${slug}`);
         activateTab(slug);
      });
   });

   // Restore from URL on load
   const hash = location.hash.slice(1);
   if (hash) activateTab(hash);

   // Handle back/forward
   window.addEventListener('popstate', (e) => {
      const slug = e.state?.slug ?? location.hash.slice(1) ?? '';
      activateTab(slug || labelToSlug(tabs[0].textContent));
   });
}
